import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { FormHelperService } from 'src/app/core/helpers/form-helper/form-helper.service';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';

@Component({
	selector: 'app-notes-tab',
	templateUrl: './notes-tab.component.html',
	styleUrls: ['./notes-tab.component.scss'],
})
export class NotesTabComponent implements OnInit {

	appointmentId: number;
	noteForm: FormGroup;
	destroyed$: Subject<boolean>;

	constructor(
		private formBuilder: FormBuilder,
		private formHelper: FormHelperService,
		private appointmentService: AppointmentService,
		private storage: LocalStorageService,
		private activatedRoute: ActivatedRoute,
	) { }

	async ngOnInit() {
		this.appointmentId = this.activatedRoute.snapshot.parent.parent.params.id;

		const note = (await this.appointmentService.getClearCodeState(this.appointmentId))?.clearCode?.note || '';

		this.noteForm = this.formBuilder.group({
			note: [note, Validators.compose([Validators.required, Validators.minLength(5)])]
		});
	}

	async onBlurSaveNote(): Promise<void> {
		this.formHelper.markAsTouched(this.noteForm, true);

		await this.saveNote(this.appointmentId, this.noteForm.controls.note.value);
	}

	private async saveNote(appointmentId: number, note: string): Promise<void> {
		const data = await this.appointmentService.getClearCodeState(appointmentId);

		data.clearCode.note = note;

		await this.storage.appointmentClearCode.setItem(this.appointmentId, data);
	}
}
